<template>
  <!-- eslint-disable max-len -->
  <svg v-if="!branding.useCustomBranding" xmlns="http://www.w3.org/2000/svg" width="114" height="130" viewBox="0 0 114 130">
    <title>Spend-Hub-Logo</title>
    <g ref="shSymbol">
      <path fill="#999" d="M114,71.48V95.21a4.53,4.53,0,0,1-2.37,4.1l-52.26,30.2a6,6,0,0,1-4.74,0L2.37,99.31A5.33,5.33,0,0,1,0,95.21V71.42l55.59,33.42a.66.66,0,0,0,.87,0L79,91.78A.43.43,0,0,0,79,91L58.25,78.58c-.36-.14-.21-.43.21-.64L80,65.54a.32.32,0,0,1,.39,0l21,12.6a.83.83,0,0,0,1,.11Z" />
      <path fill="#d1d1d1" d="M59.37.52l52.26,30.2a5.53,5.53,0,0,1,2.37,4.1V57.91L57.6,24,34.44,37.44c-.2.11-.3.31-.06.45L55.64,50.68a.79.79,0,0,1-.1,1.41l-20.68,12a.81.81,0,0,1-.77,0L12.6,51.14a1.82,1.82,0,0,0-1.89.07L0,57.43V34.82a5.53,5.53,0,0,1,2.37-4.1L54.63.52a5.65,5.65,0,0,1,4.74,0" />
    </g>
    <path ref="shHexagon" fill="none" d="M59.37.52a5.65,5.65,0,0,0-4.74,0L2.37,30.72A5.53,5.53,0,0,0,0,34.82V95.21a5.33,5.33,0,0,0,2.37,4.1l52.26,30.2a6,6,0,0,0,4.74,0l52.26-30.2a4.53,4.53,0,0,0,2.37-4.1V34.82a5.53,5.53,0,0,0-2.37-4.1L59.37.52" />
  </svg>
  <span v-else>
    <img v-if="branding.logoIconImg" :src="branding.logoIconImg" class="w-48">
  </span>
</template>

<script>
import companyBranding from '@/mixins/companyBranding';

export default {
  name: 'SpendHubLogo',
  mixins: [companyBranding],
};
</script>
